import axios from "axios";
import React, {useEffect, useRef, useState } from "react";
import { set, useForm } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import $, { error } from "jquery";
import toastr from "../../../utils/toast";
import { ToWords } from "to-words";

function AddInvoice({ order_id, onClose, onInvoiceAdded }) {
  const { register, handleSubmit, watch, setValue, formState:{ errors } } = useForm();
  const navigate = useNavigate();
  const { setGlobalLoading, token } = useOutletContext();
  const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  // const CURRENCY_API_KEY = process.env.REACT_APP_CURRENCY_API_KEY;
  const [data, setData] = useState([]);
  const [invoices, setinvoices] = useState([]);
  const retainerName = watch("name");
  const retainerAmount = watch("retainer_amount");
  const expenseOption = Number(watch("has_expense") || 0);
  const finalRetainer = Number(watch("final_retainer") || 0);
  const expenseAmount = watch("expense_amount");
  const conversionAmount = watch("conversion_rate");
  const billableAmount = watch("billable_compensation");
  const totalCompensation = watch("total_compensation");
  const comp_reveal = Number(watch("reveal") || 0);
  const esops = Number(watch("esops") || 0);
  const [currency, setCurrencies] = useState([]);
  const [retainerNameOptions, setRetainerNameOptions] = useState([]);
  const [retainerSplits, setRetainerSplits] = useState([]);
  const [finalINRAmount, setFinalINRAmount] = useState(0);
  const [totalRetainer, setTotalRetainer] = useState(0);
  const [candidate_id, setCandidateId] = useState(0);
  const [totalFees, setTotalFees] = useState(0);
  const retainerAmountManuallyChanged = useRef(false);
 // const [conversionRate, setConversionRate] = useState(1);
  // const [conversionRate, setConversionRate] = useState(null);
  const currencyId = Number(watch("currency_id") || 1);

const revenueAmount = Number(
  finalINRAmount?.toString().replace(/,/g, "") || 0
);

const enteredAmount = Number(
  watch("amount")?.toString().replace(/,/g, "") || 0
);

const isNonINRCurrency = currencyId !== 1;

// For non-INR:
// - Revenue === Amount  → disabled
// - Revenue !== Amount  → enabled
  // const isSubmitDisabled = !finalINRAmount || revenueAmount === 0 || (isNonINRCurrency && revenueAmount === enteredAmount);
 // const isSubmitDisabled = !finalINRAmount || Number(finalINRAmount.toString().replace(/,/g, "")) === 0; 
  const [compensationComponents, setCompensationComponents] = useState([]);
  const [componentValues, setComponentValues] = useState({});
  const [contractComponentTotal, setContractComponentTotal] = useState(0);
  const [componentDifference, setComponentDifference] = useState(0);
  const [allComponentTotal, setAllComponentTotal] = useState(0);
  const [totalCompensationDifference, setTotalCompensationDifference] = useState(0);

  const getOrderDetails = async () => {
      try {
     //   setGlobalLoading(true);
        const response = await axios.get( `${REACT_APP_API_BASE_URL}/orders/order_detail/${order_id}`,
          { headers: { Authorization: `Bearer ${token}` },}
        );
        let str = response.data.order_detail.retainer_splits;
        const splits = str.split(",").map(v => v.replace("%", "")).map(v => Number(v)).filter(v => v !== 0);
        setData(response.data.order_detail);
        setinvoices(response.data.invoices || []);
        setCandidateId(response.data.order_detail.closed_candidate || 0);
        setValue("invoice_id", response.data.order_detail.id);
        setValue("role_id", response.data.order_detail.role_id);
        setValue("company_id", response.data.order_detail.company_id);
        setValue("contract_id", response.data.order_detail.contract_id || 0);
        setValue('candidate_name', response.data.order_detail.candidate_name_filter);
        setValue('candidate_id', response.data.order_detail.closed_candidate || 0);
        setValue('entity_id', response.data.order_detail.entity_id || 9);
        setValue('updated_by', response.data.order_detail.role_manager_id);
        setValue('role_name', response.data.order_detail.role_name);
        setRetainerSplits(splits || []);
        const doj = response?.data?.order_detail?.doj;
        let today = new Date().toISOString().split("T")[0];
        if (!doj) {
          setValue("raised_date", today);
        } else {
          setValue("raised_date", doj);
        }
      
        if (response.data.order_detail.closed_candidate) {
            setValue("final_retainer", 1);
        }

        const contractId = response.data.order_detail.contract_id || 0;
        if (contractId) {
          const componentResponse = await axios.get(
            `${API_BASE_URL}/orders/compensation-components/${contractId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          console.log(componentResponse.data.components);
          setCompensationComponents(componentResponse.data.components || []);
        } else {
          setCompensationComponents([]);
        }
      } catch (error) {
        console.log(error);
        setGlobalLoading(false);
      } finally {
        setGlobalLoading(false);
      }
    };


  const getCurrency = async () => {
      try {
     //   setGlobalLoading(true);
        const response = await axios.get(
          `${REACT_APP_API_BASE_URL}/orders/get_currencies`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setCurrencies(response.data.options || []);

      } catch (error) {
        console.log(error);
        // setGlobalLoading(false);
      }
    };
  
  const totalCompensationInINR = Math.round(totalCompensation * conversionAmount);
  const billableCompensationInINR = Math.round(billableAmount * conversionAmount);
    
  useEffect(() => {
      retainerAmountManuallyChanged.current = false;
      const initializeInvoice = async () => {
          await Promise.all([
              getCurrency(),
              getOrderDetails()
          ]);
      };
      initializeInvoice();
  }, [order_id]);

  const calculateRemainingFee = (totalFees, invoices) => {
      const existing = invoices.reduce(
        (sum, inv) => sum + (Number(inv.retainer_amount) || 0),
        0
      );
      return { remaining: Math.round(totalFees - existing), totalExisting: existing };
  };
    
  const calculateTotalFeeFromPercentage = (billable, percent) => {
      return Math.round((Number(billable) * Number(percent)) / 100);
  };

  useEffect(() => {
      if (!data || !retainerSplits.length) return;
      const feePercent = parseFloat((data?.fee_percentage || "").toString().replace(/%/g, "")) || 0;
      const billable = Number(billableAmount || 0);
      const isPercentageFee = feePercent <= 100;
      const calculatedTotalFees = isPercentageFee && billable > 0 ? Math.round((billable * feePercent) / 100) : Number(data.total_fees || 0);
      const totalFees = calculatedTotalFees;
      const count = invoices.length;
      const { remaining, totalExisting } = calculateRemainingFee(totalFees, invoices);
      const total = invoices.reduce( (sum, inv) => sum + (Number(inv.retainer_amount) || 0), 0 ); 
      const total_expense = invoices.reduce( (sum, inv) => sum + (Number(inv.expense_amount) || 0), 0 ); 
      
      setTotalRetainer(total);
      setTotalFees(totalFees);

      let nextExpenseAmount = 0;
      let nextRetainerAmount = 0;
      const isFinalRetainer = candidate_id !== 0 && count === retainerSplits.length - 1;
      
      // -------------------------------------------------
      // FINAL RETAINER LOGIC
      // -------------------------------------------------
      if (isFinalRetainer) {
        if (isPercentageFee) {
          // Final retainer for percentage fee
          if(billable!=0){
          const totalFeeCalc = calculateTotalFeeFromPercentage(billable, feePercent);
          nextRetainerAmount = Math.round(totalFeeCalc - totalExisting);
          setTotalFees(totalFeeCalc);
          }else{
             nextRetainerAmount = remaining;
          }
        } else {
          // Final retainer for fixed fee
          nextRetainerAmount = remaining;
        }
      }
      // -------------------------------------------------
      // NORMAL (NON-FINAL) RETAINERS
      // -------------------------------------------------
      else {
        const nextSplitPercent = retainerSplits[count];
        const splitPercent = Number(nextSplitPercent);
        if (splitPercent === 33.33 || splitPercent === 33.3 || splitPercent === 33.34) {
          nextRetainerAmount = Math.round(totalFees / 3);
        } else if (splitPercent > 100) {
          nextRetainerAmount = splitPercent;
        } else {
          nextRetainerAmount = Math.round((totalFees * splitPercent) / 100);
        }
        // if (nextSplitPercent > 100) {
        //   // Fixed retainer amount in split
        //   nextRetainerAmount = nextSplitPercent;
        // } else {
        //   // Percentage split
        //   nextRetainerAmount = Math.round((totalFees * nextSplitPercent) / 100);
        // }
      }

// -------------------------------------------------
// AUTO EXPENSE CALCULATION
// -------------------------------------------------

if (expenseOption === 1) {
    const previousExpenses = total_expense || 0;
    let expPercent = parseFloat((data?.expensePercent || "").toString().replace("%", "")) || 0;
    if (isFinalRetainer) {
        // FINAL RETAINER CASE
        if (isPercentageFee) {
          if(expPercent > 100){
              nextExpenseAmount = expPercent - previousExpenses;
            }
            else if (expPercent > 0 && expPercent < 100) {
                const generatedExpense = Math.round(
                    ((Number(billable) * Number(feePercent)) / 100) * (expPercent / 100)
                );
                nextExpenseAmount = generatedExpense - previousExpenses;
            } else {
                nextExpenseAmount = 0;
            }
        } else {
            const fixedExpense = Math.round((totalFees * expPercent) / 100);
            nextExpenseAmount = Math.max(fixedExpense - previousExpenses, 0);
        }
    } 
    else {
        // NOT FINAL RETAINER → Expense should not auto-fill
       let totalExpense = 0;
       if(expPercent>100){
          totalExpense = Math.round(expPercent - previousExpenses);
        }else{
          totalExpense = Math.round((nextRetainerAmount * expPercent) / 100);
        }
        nextExpenseAmount = totalExpense;
    }
}


      // Update Form
      if (!retainerAmountManuallyChanged.current) {
          setValue("retainer_amount", nextRetainerAmount || 0);
        }
      setValue("expense_amount", nextExpenseAmount || 0);
      setValue("total_fees",totalFees);
      setValue("fee_percentage",feePercent);
      // -------------------------------------------------
      // RETAINER NAME OPTIONS
      // -------------------------------------------------
      const options = [];
      if (retainerSplits.length > 1) options.push("First Retainer");
      if (retainerSplits.length > 2) options.push("Second Retainer");
      if (retainerSplits.length > 3) options.push("Third Retainer");
      if (candidate_id !== 0) options.push("Final Retainer");
      options.push("Expenses Invoice", "Adjustment Invoice");
      setRetainerNameOptions(options);

      // Default Name
      let defaultName = "";
      if (finalRetainer === 1) {
            defaultName = "Final Retainer";
        } 
        else {
            // Normal (non-final) logic
            const nameMap = ["First Retainer", "Second Retainer", "Third Retainer"];
            defaultName = nameMap[count] || "Adjustment Invoice";
        }
      setTimeout(() => setValue("name", defaultName), 0);
  }, [invoices, data, candidate_id, retainerSplits, finalRetainer, billableAmount, expenseOption]);

  useEffect(() => {
  if (retainerName === "Final Retainer") {
    setValue("final_retainer", 1);
  } else {
    setValue("final_retainer", 0);
  }
  }, [retainerName]);
  
  useEffect(() => {
    const retainer = Number(retainerAmount) || 0;
    const expense =
        expenseOption === 1
            ? Number(expenseAmount) || 0
            : 0;

    const finalAmount = retainer + expense;

    const formattedAmount = Number.isInteger(finalAmount)
        ? finalAmount
        : Number(finalAmount.toFixed(2));

    setValue("amount", formattedAmount);

    // Don't calculate until conversion is available
    if (conversionAmount === null || conversionAmount === undefined) {
        setFinalINRAmount(0);
        return;
    }

    const inrAmount = Math.round(
        formattedAmount * Number(conversionAmount)
    );

    setFinalINRAmount(inrAmount);

}, [
    retainerAmount,
    expenseAmount,
    expenseOption,
    conversionAmount
]);

  // useEffect(() => {
  //     const retainer = Number(retainerAmount) || 0;
  //     const expense = expenseOption === 1 ? Number(expenseAmount) || 0 : 0;
  //     const finalAmount = retainer + expense;
  //     // Show 2 decimals only if required
  //     const formattedAmount = Number.isInteger(finalAmount)
  //       ? finalAmount
  //       : Number(finalAmount.toFixed(2));
  //     setValue("amount", formattedAmount);

  //     const inr = format_currency(Math.round(formattedAmount * conversionAmount));
  //   //  setFinalINRAmount(inr);
  //     if(formattedAmount==0){
  //       setFinalINRAmount(1);
  //     }else{
  //       setFinalINRAmount(inr);
  //     }
      
  //   }, [retainerAmount, expenseAmount, expenseOption, conversionAmount]);

  // useEffect(() => {
  //   if (currency.length > 0) {
  //     setValue("currency_id", data.currency_id || 1);
  //   }
  // }, [currency,data]);

  // useEffect(() => {
  //   const selected = watch("currency_id");
  //   if (selected) {
  //     handleCurrencyChange({ target: { value: selected } });
  //   }
  // }, [watch("currency_id")]);

  useEffect(() => {
    if (!currency?.length || !data?.currency_id) {
        return;
    }

    const selectedCurrencyId = Number(data.currency_id);

    // Set currency in form
    setValue("currency_id", selectedCurrencyId, {
        shouldDirty: false,
        shouldValidate: false
    });

    const selectedCurrency = currency.find(
        c => Number(c.id) === selectedCurrencyId
    );

    if (!selectedCurrency?.name) {
        console.warn(
            "Currency not found:",
            selectedCurrencyId,
            currency
        );
        return;
    }

    // INR does not need external conversion
    if (selectedCurrencyId === 1) {
        setValue("conversion_rate", 1);
        // setConversionRate(1);
        return;
    }

    // Non-INR currency → fetch conversion
    getConversation(selectedCurrency.name);

}, [currency, data?.currency_id]);

  useEffect(() => {
  if (Number(esops) !== 1) {
    setValue("esops_val", "0");
  }
}, [esops]);

  useEffect(() => {
    if (!invoices || invoices.length === 0) return;

    const hasFinalInvoice = invoices.some(
      (inv) => Number(inv.final_retainer) === 1
    );

    if (hasFinalInvoice) {
      // Reset candidate & final retainer
      setCandidateId(0);
      setValue("candidate_id", 0);

      setValue("final_retainer", 0);
    }
  }, [invoices]);

  function format_currency(num) {
      const isFloat = !Number.isInteger(num);
      return new Intl.NumberFormat("en-IN", {
          minimumFractionDigits: isFloat ? 0 : 0, // show 2 decimals only if float
          maximumFractionDigits: isFloat ? 0 : 0,
      }).format(num);
    }

  // const getConversation = async (name) => {
  //     try {
  //       const response = await axios.get(
  //         `https://api.currconv.com/api/v7/convert?q=${name}_INR&compact=ultra&apiKey=${CURRENCY_API_KEY}`
  //       );
  //       const rate = response.data || {};
  //       const [currency, value] = Object.entries(rate)[0];
  //       const roundedValue = value ? Number(value.toFixed(3)) : 1;
  //       setValue("conversion_rate", roundedValue || 1);
  //       setConversionRate(roundedValue ?? 1);
  //     } catch (error) {
  //       console.log(error);
  //       setGlobalLoading(false);
  //     }
  //   };

//   const getConversation = async (name) => {
//     if (!name) {
//         console.warn("Currency name missing");
//         return;
//     }

//     try {
//         const response = await axios.get(
//             `https://api.currconv.com/api/v8/convert?q=${name}_INR&compact=ultra&apiKey=${CURRENCY_API_KEY}`
//         );

//         const rate = response.data || {};
//         const entries = Object.entries(rate);

//         if (!entries.length) {
//             throw new Error(`No conversion rate returned for ${name}`);
//         }

//         const [, value] = entries[0];

//         if (!value || Number(value) <= 0) {
//             throw new Error(`Invalid conversion rate for ${name}: ${value}`);
//         }

//         const roundedValue = Number(Number(value).toFixed(3));

//         console.log("Currency conversion:", {
//             currency: name,
//             rate: roundedValue
//         });

//         setValue("conversion_rate", roundedValue, {
//             shouldDirty: false,
//             shouldValidate: false
//         });

//         setConversionRate(roundedValue);

//     } catch (error) {
//         console.error(
//             `Currency conversion failed for ${name}:`,
//             error
//         );

//         // IMPORTANT:
//         // Do NOT fall back to 1 for non-INR currencies.
//         setValue("conversion_rate", null);
//         setConversionRate(null);
//     }
// };

  const getConversation = async (name) => {
    if (!name) {
      console.warn("Currency name missing");
      return;
    }

    try {
      const response = await axios.get(
        `${API_BASE_URL}/common_controller/currency-conversion`,
        {
          params: {
            currency: name,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const rate = Number(response.data?.rate);

      if (!rate || rate <= 0) {
        throw new Error(`Invalid conversion rate returned for ${name}: ${response.data?.rate}`);
      }

      const roundedValue = Number(rate.toFixed(3));
      console.log("Currency conversion:", {currency: name, rate: roundedValue});
      setValue("conversion_rate", roundedValue, {shouldDirty: false, shouldValidate: false});
      // setConversionRate(roundedValue);
    } catch (error) {
      console.error(
        `Currency conversion failed for ${name}:`,
        error
      );

      setValue("conversion_rate", null);
      // setConversionRate(null);
    }
  };
  const handleCurrencyChange = (e) => {
      const selectedCurrencyId = parseInt(e.target.value);
      if (selectedCurrencyId) {
        const currencyVal = currency?.find(
          (c) => c.id === selectedCurrencyId
        )?.name;
        getConversation(currencyVal);
      }
    };  

  const toWords = new ToWords({
    localeCode: "en-IN",
    converterOptions: {
      currency: true,
      ignoreDecimal: true,
    },
  });
  const amount = Number(finalINRAmount?.toString().replace(/,/g, "") || 0); 
  const onSubmit = async (data) => {
    try {
        // Fixed / Base Salary is mandatory only when
        // Compensation Breakup is Revealed
        if (Number(data.reveal) === 1 && Number(data.final_retainer) === 1) {
          const fixedBaseSalaryComponent = compensationComponents.find(
            (component) => component.component_name?.toLowerCase().trim() === "fixed / base salary"
          );

          if (fixedBaseSalaryComponent) {
            const componentId = fixedBaseSalaryComponent.component_id ?? fixedBaseSalaryComponent.id;
            const fixedBaseSalary = componentValues?.[componentId]?.amount;
            if (
              fixedBaseSalary === undefined ||
              fixedBaseSalary === null ||
              fixedBaseSalary === "" ||
              Number(fixedBaseSalary) <= 0
            ) {
              toastr.error("Fixed / Base Salary is mandatory.");
              return;
            }
          }
        }
      setGlobalLoading(true);
      const formData = new FormData();
      const fixedAmount = componentValues?.[1]?.amount || "";
      const variableAmount = componentValues?.[2]?.amount || "";
      data.fixed = fixedAmount;
      data.variable = variableAmount;
      
      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value ?? "");
      });
      formData.append(
        "compensation_components",
        JSON.stringify(componentValues)
      );
      if (data.file_name && data.file_name.length > 0) {
          formData.append("file_name", data.file_name[0]); 
        }
      const response = await axios.post(
        `${API_BASE_URL}/orders/add_new_invoice`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
    //  console.log(response);
      toastr.success("Invoice added successfully!");
      onInvoiceAdded();
      onClose();
    } catch (err) {
      console.error("Submission failed:", err);
      alert("Error updating User.");
    } finally {
      setGlobalLoading(false);
    }
    };  
    
  useEffect(() => {

    // ==========================================
    // 1. AVAILABLE COMPONENT TOTAL Compare with Billable Compensation
    // ==========================================

    const availableTotal = compensationComponents.reduce(
      (sum, component) => {
        const componentId = component.component_id ?? component.id;
        const value = Number(componentValues?.[componentId]?.amount || 0);
        if (Number(component.available_in_contract) === 1) {
          return sum + value;
        }
        return sum;
      },
      0
    );
    setContractComponentTotal(availableTotal);
    const billable = Number(billableAmount || 0);
    setComponentDifference(billable - availableTotal);

    // ==========================================
    // 2. ALL COMPONENT TOTAL Compare with Total Compensation
    // ==========================================

    const allTotal = compensationComponents.reduce(
      (sum, component) => {
        const componentId = component.component_id ?? component.id;
        const value = Number(componentValues?.[componentId]?.amount || 0);
        return sum + value;
      },
      0
    );

    setAllComponentTotal(allTotal);
    const totalComp = Number(totalCompensation || 0);
    setTotalCompensationDifference(totalComp - allTotal);
  }, [componentValues, compensationComponents, billableAmount, totalCompensation]);

  const conversionReady = conversionAmount !== null && conversionAmount !== undefined && Number(conversionAmount) > 0;
  const isSubmitDisabled = !conversionReady || (isNonINRCurrency &&  revenueAmount !== 0 && revenueAmount === enteredAmount);

return (
   <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h4 className="modal-title">Add Invoice</h4>
              <button onClick={() => onClose()} type="button" className="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
                <i className="ti ti-x"></i>
              </button>
            </div>

            <div className="modal-body row" style={{ textAlign: "left" }}>
              <div className="row">
                  <div className="col-md-4 col-sm-4">
                    <div className="mb-2">
                        <label className="form-label">Retainer Name *</label>
                        <select {...register("name", { required: "required" })} className={`form-select ${errors.name && "is-invalid"}`}>
                          {retainerNameOptions.map((opt, index) => (
                            <option key={index} value={opt}>{opt}</option>
                          ))}
                        </select>
                        <input type="hidden" {...register("role_id")} />
                        <input type="hidden" {...register("company_id")} />
                        <input type="hidden" {...register("contract_id")} />
                        <input type="hidden" {...register("invoice_id")} />
                        <input type="hidden" {...register("entity_id")} />
                        <input type="hidden" {...register("updated_by")} />
                        <input type="hidden" {...register("role_name")} />
                    </div>
                  </div>
                  {candidate_id != 0 && (
                    <div className="col-md-4 col-sm-4">
                      <div className="mb-2">
                          <label className="form-label">Final Retainer * </label>
                          <select {...register("final_retainer")} className="form-select">
                            <option value="0">No</option>
                            <option value="1">Yes</option>
                          </select>
                          <span className="fs-10"><i>Select “Yes” to combine all pending fees.</i></span>
                      </div>
                    </div> 
                    )}
                  <div className="col-md-4 col-sm-4">
                    <div className="mb-2">
                        <label className="form-label">Raised Date * <span className="fs-10 ms-2">(Trigger & Reporting)</span></label>
                        <div className="input-icon position-relative w-100 me-2">
                            <input {...register(`raised_date`, { required: "required"})} type="date" className={`datetimepicker form-control ${ errors.raised_date && "is-invalid"}`} placeholder="dd/mm/yyyy" />
                        </div>
                    </div>
                  </div>
                  
                {candidate_id != 0 && finalRetainer === 1 ? (  
                  <div className="row">
                    <div className="col-md-4 col-sm-4">
                      <div className="mb-2">
                        <label className="form-label">Candidate Name * </label>
                        <input type="text" {...register("candidate_name", { required: "required" })} className={`form-control ${ errors.cnadidate_name && "is-invalid"}`} readOnly />
                        <input type="hidden" {...register("candidate_id")} />
                        <input type="hidden" {...register("fee_percentage")} />
                        <input type="hidden" {...register("total_fees")} />
                      </div>
                    </div>   
                    <div className="col-md-4 col-sm-4">
                      <div className="mb-2">
                        <label className="form-label">Billable Compensation * </label>
                        <input type="text" {...register("billable_compensation", {
                          required: "required",
                          onChange: (e) => {
                            let value = e.target.value;
                            value = value.replace(/[^0-9.]/g, "");
                            value = value.replace(/(\..*)\./g, "$1");
                            e.target.value = value;
                            setValue("billable_compensation", value, { shouldValidate: true });
                            }
                          })}
                          className={`form-control ${errors.billable_compensation && "is-invalid"}`}
                        />
                        <br />
                      <span className="fs-10 ms-2">
                        {Number(billableCompensationInINR) > 0
                          ? toWords.convert(Number(billableCompensationInINR))
                          : ""}
                      </span>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-4">
                      <div className="mb-2">
                        <label className="form-label">Total Compensation * </label>
                        <input type="text" {...register("total_compensation", { 
                          required: "required", 
                          onChange: (e) => {
                          let cleaned = e.target.value.replace(/[^0-9.]/g, "");
                          cleaned = cleaned.replace(/(\..*)\./g, "$1");
                          e.target.value = cleaned;
                          return cleaned;
                        }})} className={`form-control ${ errors.total_compensation && "is-invalid"}`} />
                        <br />
                      <span className="fs-10 ms-2">
                        {Number(totalCompensationInINR) > 0
                          ? toWords.convert(Number(totalCompensationInINR))
                          : ""}
                      </span>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-4"></div>
                    <div className="col-md-4 col-sm-4 fs-10"><i>Compensation on which fees are charged</i></div>
                    <div className="col-md-4 col-sm-4 fs-10"><i>Complete compensation offered to candidate</i></div>
                  </div>
                ) : ("")}  
                  <div className="row">
                      <div className="col-md-3 col-sm-3">
                        <div className="mb-2">
                          <label className="form-label">Retainer Amount * </label>
                          <input type="text" {...register("retainer_amount", { required: "required",
                              onChange: (e) => { let value = e.target.value;
                                value = value.replace(/[^0-9.]/g, "");
                                value = value.replace(/(\..*)\./g, "$1");
                                e.target.value = value;
                                // Mark retainer amount as manually changed
                                retainerAmountManuallyChanged.current = true;
                                setValue("retainer_amount", value, {
                                  shouldValidate: true,
                                  shouldDirty: true,
                                });
                              },
                            })}
                            className={`form-control ${errors.retainer_amount && "is-invalid"}`}
                          />
                        </div>
                      </div>
                      <div className="col-md-2 col-sm-2">
                        <div className="mb-2">
                          <label className="form-label"> </label>
                            <select {...register("currency_id", {
                                  required: true,
                                  onChange: (e) => handleCurrencyChange(e),
                                })} className="form-select" disabled>
                                {currency.map((m) => (
                                  <option key={m.id} value={m.id}>
                                    {m.symbol} - {m.name}
                                  </option>
                                ))}
                              </select>
                        </div>
                      </div>
                      <div className="col-md-3 col-sm-3">
                          <div className="mb-2">
                              <label className="form-label">Expense * </label>
                              <select {...register("has_expense")} className="form-select">
                                <option value="0">No</option>
                                <option value="1">Yes</option>
                              </select>
                          </div>
                      </div>
                      <div className="col-md-4 col-sm-4">
                          {expenseOption === 1 ? (
                          <div className="mb-2">
                              <label className="form-label">Expense Amount</label>
                              <input type="text" {...register("expense_amount", { required: "required" })} className={`form-control ${ errors.expense_amount && "is-invalid"}`} />
                          </div>
                          ) : ("")} 
                      </div>
                  </div>    
                  <div className="row col-md-12 col-sm-12">
                    <div className="col-md-3 col-sm-3">
                      <span className="fs-11"><i>Total Fees: {data?.symbol}{" "} {format_currency(totalFees)} ({data?.curreny_name})</i></span>
                    </div>
                    <div className="col-md-3 col-sm-3">
                      <span className="fs-11"><i>Raised Amount: {data?.symbol}{" "} {format_currency(totalRetainer)} ({data?.curreny_name})</i></span>
                    </div>
                    <div className="col-md-3 col-sm-3">
                      <span className="fs-11"><i>(Expense Percent/Fee: {data?.expensePercent})</i></span>
                    </div>
                    <div className="col-md-3 col-sm-3">
                      <span className="fs-11"><i>Remaining Amount: {data?.symbol}{" "} {format_currency(totalFees - totalRetainer - retainerAmount)}</i></span>
                    </div>
                  </div> 
                  <div className="col-md-6 col-sm-6">
                  <div className="mb-2">
                    <label className="form-label">Final Amount * </label>
                    <input type="text" {...register("amount")} className={`form-control ${ errors.amount && "is-invalid"}`} readOnly />
                    <input type="hidden" {...register("conversion_rate")} />
                  </div>
                  </div>
                  <div className="col-md-6 col-sm-6">
                  <div className="mb-2">
                    <label className="form-label">Comments</label>
                    <input type="text" {...register("comments")} className={`form-control ${ errors.comments && "is-invalid"}`} />
                  </div>
                  </div>
                  {/* <div className="col-md-6 col-sm-6">
                  <div className="mb-2">
                    <label className="form-label">Conversion Rate *</label>
                    <input type="text" className={`form-control ${errors.conversion_rate ? "is-invalid" : ""}`} placeholder="Fees Conversion Rate" {...register("conversion_rate", { required: true })} autoComplete="off" value={conversionRate ?? 1} />
                  </div>
                  </div> */}
                  <div className="col-md-12 col-sm-12">
                    <div className="mb-2">
                      <span className="fs-12 ms-2">
                        (Revenue in INR: {finalINRAmount})
                      </span>
                      <br />
                      <span className="fs-12 ms-2">
                        {toWords.convert(amount)}
                      </span>
                    </div>
                  </div>
                  
                  {candidate_id != 0 && finalRetainer === 1 ? ( 
                  <>
                  <div className="col-md-6 col-sm-6">
                    <div className="mb-2">
                          <select {...register("reveal")} className="form-select">
                            <option value="1">Compensation Breakup Revealed</option>
                            <option value="0">Compensation Breakup Not Shared By Client</option>
                          </select>
                      </div>
                  </div>
                  <input type="hidden" {...register("fixed")} />
                  <input type="hidden" {...register("variable")} />
                  {Number(comp_reveal) === 1 && compensationComponents.length > 0 && (
                    <div className="row col-sm-12">

                      {["compensation", "other_cash", "equity"].map((category) => {

                        const categoryComponents = compensationComponents.filter(
                          (component) => component.category === category
                        );

                        if (categoryComponents.length === 0) {
                          return null;
                        }

                        const categoryTitle =
                          category === "compensation"
                            ? "Compensation"
                            : category === "other_cash"
                            ? "Other Cash Components in Year 1"
                            : "Equity Compensation";

                        return (
                          <div key={category} className="mb-4">

                            <h5 className="mb-3">{categoryTitle}</h5>

                            <div className="row">

                              {categoryComponents.map((component) => {
                                const isFixedBaseSalary = component.component_name?.toLowerCase().trim() === "fixed / base salary";
                                const componentId = component.component_id ?? component.id;
                                const isText = component.value_type === "text" || component.value_type === "string";
                                const isAvailable = Number(component.available_in_contract) === 1;
                                return (
                                  <div className="col-md-4 col-sm-6" key={componentId}>
                                    <div className="mb-2">
                                      <label className="form-label">
                                        {component.component_name}
                                        {/* {Number(component.applicable) === 1 && " *"} */}
                                         {isFixedBaseSalary && (
                                            <span className="text-danger ms-1">*</span>
                                          )}

                                          {isAvailable && (
                                            <span className="text-success ms-1">
                                              ✓
                                            </span>
                                          )}
                                      </label>

                                      {isText ? (
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={
                                            componentValues?.[componentId]?.value_text || ""
                                          }
                                          onChange={(e) => {
                                            setComponentValues((prev) => ({
                                              ...prev,
                                              [componentId]: {
                                                ...(prev[componentId] || {}),
                                                value_text: e.target.value,
                                              },
                                            }));
                                          }}
                                        />
                                      ) : (
                                        <input
                                          type="text"
                                          className="form-control"
                                          required={isFixedBaseSalary && Number(comp_reveal) === 1}
                                          value={componentValues?.[componentId]?.amount || ""}
                                          onChange={(e) => {

                                            let value = e.target.value
                                              .replace(/[^0-9.]/g, "")
                                              .replace(/(\..*)\./g, "$1");

                                            setComponentValues((prev) => ({
                                              ...prev,
                                              [componentId]: {
                                                ...(prev[componentId] || {}),
                                                amount: value,
                                              },
                                            }));

                                          }}
                                        />
                                      )}

                                      {isAvailable && (
                                        <small className="text-success">
                                          Included in billable compensation
                                        </small>
                                      )}

                                    </div>
                                  </div>
                                );
                              })}

                            </div>

                          </div>
                        );
                      })}

                      {/* COMPONENT TOTAL */}
                      <div className="col-md-12">
                        <div className="border-top pt-3 mt-2">

                          <div className="d-flex justify-content-between">
                            <strong>Billable Compensation Total</strong>
                            <strong>{format_currency(contractComponentTotal)}</strong>
                          </div>

                        </div>
                      </div>

                <div className="mt-2">
                  {Number(billableAmount || 0) > 0 && compensationComponents.length > 0 ? (
                    Number(billableAmount) === Number(contractComponentTotal) ? (
                      <div className="text-success fs-11">
                        <i className="ti ti-check me-1"></i>
                        The Billable Compensation of <strong className="ms-1">{format_currency(contractComponentTotal)}</strong> entered above matches the total of the billable compensation components specified in the corresponding contract for this order.
                      </div>
                    ) : (

                      <div className="text-danger fs-11">
                        <i className="ti ti-alert-circle me-1"></i>
                        The Billable Compensation of <strong className="mx-1">{format_currency(Number(billableAmount))}</strong> entered above does not match the total of the billable compensation components specified in the corresponding contract for this order.
                        <br />
                        Difference:
                        <strong className="ms-1">
                          {format_currency(Math.abs(Number(billableAmount) - contractComponentTotal))}
                        </strong>
                      </div>
                    )
                  ) : null}
                </div>  
                {Number(totalCompensation || 0) > 0 && compensationComponents.length > 0 ? (
                  <>
                    {/* Total of All Components */}
                    <div className="col-md-12">
                      <div className="pt-3 mt-2">
                        <div className="d-flex justify-content-between">
                          <strong>Total Compensation (excluding stocks)</strong>
                          <strong>
                            {format_currency(allComponentTotal)}
                          </strong>
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}
                
                {/* Total Compensation vs ALL Component Total */}
                
                <div className="mt-2">
                  {Number(totalCompensation || 0) > 0 && compensationComponents.length > 0 ? (
                    Number(totalCompensation) === Number(allComponentTotal) ? (
                      <div className="text-success fs-11">
                        <i className="ti ti-check me-1"></i>
                        The Total Compensation of <strong className="ms-1">{format_currency(allComponentTotal)}</strong> entered above matches the total of the cash compensation components entered above.
                      </div>
                    ) : (
                      <div className="text-danger fs-11">
                        <i className="ti ti-alert-circle me-1"></i>
                        The Total Compensation of <strong className="mx-1">{format_currency(Number(totalCompensation))}</strong> entered above does not match the total of the cash compensation components entered above.
                        <br />
                        Difference:
                        <strong className="ms-1">
                          {format_currency(Math.abs(Number(totalCompensation) - allComponentTotal))}
                        </strong>
                      </div>
                    )
                  ) : null}

                </div>
                    </div>
                  )}

                  {/* {Number(comp_reveal) === 1 && (
                  <div className="row col-sm-12">
                    <div className="col-md-4 col-sm-4">
                      <div className="mb-2">
                          <label className="form-label">Fixed Amount *</label>
                          <input type="text" {...register("fixed", {
                            required: "required",
                            onChange: (e) => {
                              let value = e.target.value;
                              value = value.replace(/[^0-9.]/g, "");
                              value = value.replace(/(\..*)\./g, "$1");
                              e.target.value = value;
                              setValue("fixed", value, { shouldValidate: true });
                              }
                            })}
                            className={`form-control ${errors.billable_compensation && "is-invalid"}`}
                          />
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-4">
                      <div className="mb-2">
                          <label className="form-label">Variable Amount *</label>
                          <input type="text" {...register("variable", {
                            required: "required",
                            onChange: (e) => {
                              let value = e.target.value;
                              value = value.replace(/[^0-9.]/g, "");
                              value = value.replace(/(\..*)\./g, "$1");
                              e.target.value = value;
                              setValue("variable", value, { shouldValidate: true });
                              }
                            })}
                            className={`form-control ${errors.billable_compensation && "is-invalid"}`}
                          />
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-4">
                      <div className="mb-2">
                        <label className="form-label">Other Comp Details *</label>
                          <input type="text" {...register("others", { required: "required" })} className={`form-control ${ errors.others && "is-invalid"}`} />
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-6">
                      <div className="mb-2">
                        <label className="form-label">Compensation File</label>
                          <input type="file" className="form-control" {...register("file_name")} />
                      </div>
                    </div>         
                    <div className="col-md-3 col-sm-3">
                      <div className="mb-2">
                          <label className="form-label">ESOPs/RSUs</label>
                          <select {...register("esops")} className="form-select">
                              <option value="0">No</option>
                              <option value="1">Yes</option>
                            </select>
                        </div>
                    </div>
                    {Number(esops) === 1 && (
                    <div className="col-md-3 col-sm-3">
                      <div className="mb-2">
                        <label className="form-label">Esops Value *</label>
                          <input type="text" {...register("esops_val", {
                            required: "required",
                            onChange: (e) => {
                              let value = e.target.value;
                              value = value.replace(/[^0-9.]/g, "");
                              value = value.replace(/(\..*)\./g, "$1");
                              e.target.value = value;
                              setValue("esops_val", value, { shouldValidate: true });
                              }
                            })}
                            className={`form-control ${errors.billable_compensation && "is-invalid"}`}
                          />
                        </div>
                    </div>
                    )}
                  </div>
                  )} */}

                  </>
                   ) : ("")}

              </div>
            </div>
            <div className="modal-footer">
              {/* {isSubmitDisabled && (
                <div className="text-danger mt-1 small">
                  Please wait for the currency conversion to complete.
                </div>
              )} */}
              {/* <button type="submit" className="btn btn-primary"
               disabled={!finalINRAmount || Number(finalINRAmount.toString().replace(/,/g, "")) === 0}>
                Submit
              </button> */}
              {!conversionReady && (
                <div className="text-danger mt-1 small">
                  Please wait for the currency conversion to complete.
                </div>
              )}
              <button type="submit" className="btn btn-primary" disabled={isSubmitDisabled}>
                Submit
              </button>
              <button onClick={onClose} type="button" className="btn btn-secondary ms-2" data-bs-dismiss="modal" aria-label="Close">
                Close
              </button>
            </div>
          </form>
        </div>
      </div>
   </div> 
);
}    

export default AddInvoice;